var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpAndDownGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52813 2.32204C6.69546 2.49634 6.68981 2.77329 6.5155 2.94062C6.31702 3.13117 6.03752 3.06251 5.89668 2.92775C5.30654 2.31642 4.69525 1.70561 4.02502 1.18194L4.02502 6.5625C4.02502 6.80413 3.82915 7 3.58752 7C3.3459 7 3.15002 6.80413 3.15002 6.5625L3.15002 1.18194C2.47916 1.70612 1.86835 2.31654 1.27812 2.92801C1.11079 3.1023 0.833844 3.10795 0.659543 2.94062C0.485237 2.77329 0.479753 2.49616 0.647085 2.32186C1.29086 1.65486 1.95181 0.991096 2.69169 0.430573C2.94401 0.23942 3.25526 0 3.58752 0C3.91979 0 4.23104 0.23942 4.48335 0.430573C5.22121 0.989561 5.88667 1.65741 6.52813 2.32204Z",
    fill: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5281 9.67796C11.6955 9.50366 11.6898 9.22671 11.5155 9.05938C11.317 8.86883 11.0375 8.93749 10.8967 9.07225C10.3065 9.68358 9.69525 10.2944 9.02502 10.8181L9.02502 5.4375C9.02502 5.19587 8.82915 5 8.58752 5C8.3459 5 8.15002 5.19587 8.15002 5.4375L8.15002 10.8181C7.47916 10.2939 6.86835 9.68346 6.27812 9.07199C6.11079 8.8977 5.83384 8.89205 5.65954 9.05938C5.48524 9.22671 5.47975 9.50384 5.64708 9.67814C6.29086 10.3451 6.95181 11.0089 7.69169 11.5694C7.94401 11.7606 8.25526 12 8.58752 12C8.91979 12 9.23104 11.7606 9.48335 11.5694C10.2212 11.0104 10.8867 10.3426 11.5281 9.67796Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpAndDownGrayOutline);
export default __webpack_public_path__ + "static/media/arrowUpAndDownGrayOutline.ba3072e6bb12f54d01cb54cefedc553a.svg";
export { ForwardRef as ReactComponent };